import React from 'react';

import Modal from '~components/Modal';
import {Project} from "~screens/Dashboard/screens/Projects/types";
import {Map} from '~screens/Dashboard/screens/ProjectsIIRSA/screens/ElementsMap/components/Map';

import styles from './styles.module.scss';

interface Props {
    project: Project;
    isOpen: boolean;
    closeModal: Function;
    className?: string;
}

function ModalContent({project, ...rest}: Props) {

    const zoom = project.dynamicCenter ? project.dynamicCenter.zoom : 10;

    return (
        <Modal title={project.name} {...rest}>
            <div className={`row full-width ${styles.containerMap}`}>
                <Map elements={[project]} zoom={zoom}/>
            </div>
        </Modal>
    );
}

export default ModalContent;
